'use strict';

var Utils = require('../../utils/utils');

var Fixed = function(config) {

  var self = this;
  var $header = $(config.header);
  var $window = $(window);
  var $body = $('body');
  var headerHeight = $header.outerHeight();
  var winWidth = $window.width();
  var newWidth = winWidth;

  self.setStyles = function(headerHeight) {
    $header.addClass('is-fixed');
    $body.css('padding-top', headerHeight);
  }

  self.updateSizes = function() {
    headerHeight = self.getHeaderHeight();
    self.setStyles(headerHeight);
  }

  self.getHeaderHeight = function() {
    var $clone = $header
                  .clone()
                  .css({
                    'visibility': 'hidden',
                    'position': 'absolute',
                    'top': '0'
                  })
                  .addClass('is-clone')
                  .removeClass('is-fixed -scrolled')
                  .appendTo($body);
    var height = $clone.outerHeight();
    $clone.remove();
    return height;
  }

  self.winResizeHandler = function() {
    $window.on('resize.fixedHeader', new Utils().throttle(function() {

      newWidth = $window.width();

      if (winWidth !== newWidth) {
        self.updateSizes();

        setTimeout(function () {
          self.updateSizes();
        }, 4000);
      }
    }, 60));
  }

  self.init = function() {
    self.updateSizes();
    self.winResizeHandler();

    $(window).on('load', function() {
      setTimeout(function () {
        self.updateSizes();
      }, 2000);
    });
  }
};

module.exports = Fixed;
